export default __webpack_public_path__ + "static/media/girl.9ec0bc80.png";